import { computed } from '@vue/reactivity';
/**
 * icon-svg 组件（展示所有的svg）
 */

export default {
  name: 'BaseSvgIcon',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    iconClass: {
      type: String
    },
    // eslint-disable-next-line vue/require-default-prop
    className: {
      type: String
    }
  },
  setup: function setup(props) {
    var iconName = computed(function () {
      return props.iconClass ? "#icon-".concat(props.iconClass) : '#icon';
    });
    var svgClass = computed(function () {
      return props.className ? 'svg-icon ' + props.className : 'svg-icon';
    });
    return {
      iconName: iconName,
      svgClass: svgClass
    };
  }
};